/* ============================================================
   sm-trust.js

   Traustatriðin á vörusíðum bera tákn sem eru STAFIR, ekki myndir:
   ☂ ✦ ↺ teiknaðir í Fraunces. Þau eru harðkóðuð inni í
   sections/sm-product*.liquid, sem eru 15 til 30KB hver, og að
   endurrita þrjár slíkar skrár til þess eins að skipta um tákn er
   meiri áhætta en ávinningur.

   Þessi skrá les stafinn og setur alvöru SVG í staðinn. Hún keyrir
   eftir að skjalið er lesið, breytir engu öðru, og ef hún fer aldrei
   í gang stendur upphaflega táknið eftir í réttri stærð og lit.
   Það er því viðbót, ekki forsenda.

   Ef nýtt tákn bætist við í Liquid og er ekki í töflunni hér fyrir
   neðan gerist ekkert, stafurinn stendur einfaldlega áfram.
   ============================================================ */
(function () {
  var S = 'viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"';

  var ICONS = {
    /* Regnhlíf: veðurþol, UV-vörn */
    '☂':
      '<svg ' + S + ' aria-hidden="true">' +
      '<path d="M12 2.6v2.3"/>' +
      '<path d="M2.9 12.7a9.1 9.1 0 0 1 18.2 0c-1.5-1.1-3-1.1-4.5 0-1.5-1.1-3.1-1.1-4.6 0-1.5-1.1-3.1-1.1-4.6 0-1.5-1.1-3-1.1-4.5 0Z"/>' +
      '<path d="M12 12.7v6.4a2.3 2.3 0 0 0 4.6 0"/>' +
      '</svg>',

    /* Fjórarma stjarna: sérsmíði, handverk */
    '✦':
      '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
      '<path d="M12 3c1.2 5.8 3 7.6 8.8 8.8C15 13 13.2 14.8 12 20.6 10.8 14.8 9 13 3.2 11.8 9 10.6 10.8 8.8 12 3Z"/>' +
      '</svg>',

    /* Hringör: nýtt skilti, ánægjuábyrgð */
    '↺':
      '<svg ' + S + ' aria-hidden="true">' +
      '<path d="M20.4 12a8.4 8.4 0 1 1-2.5-6"/>' +
      '<path d="M20.7 3.8v5.1h-5.1"/>' +
      '</svg>'
  };

  /* ---------- Greiðslumerkin á hurðaskilta-, lyklakippu- og gæludýrasíðunum ----------

     Merkin birtust alls staðar nema þar. Ástæðan er ekki stilling í
     appinu heldur þessi lína í skriftu þess:

         jQuery('form[action*="/cart/add"]')

     Appið festir merkin fyrir aftan körfuformið. Stillibúnaður
     hurðaskiltanna notar <form data-hurda-form> ÁN action, því hann
     setur í körfu með fetch, svo leitin skilar engu og ekkert er sett
     inn. Kóðinn er sendur á síðuna, hann er bara aldrei notaður.

     Appið býður sjálft upp á akkeri:

         girafflyTrust[i].innerHTML = e;                  // fyllir akkerið
         setInterval(() => { ... trustRes() }, 1000)      // og pollar

     Það nægir því að búa til tóman div með þessum klasa. Appið fyllir
     hann innan sekúndu.

     Það liggur beinna við að gefa forminu action="/cart/add", og það
     væri réttara Shopify-form, en sú breyting snertir hegðun forms sem
     er þegar í notkun. Þetta snertir hana ekki.

     Og þetta bætir engri viðkvæmni við: merkin eru sett inn með
     JavaScript á ÖLLUM síðum hvort eð er. Ef skriftur liggja niðri
     eru engin merki neins staðar, með þessum div eða án hans. */
  var PAY_ANCHOR = 'giraffly-trust-badge-690d236249201-92213237-721762468706';

  function payAnchor() {
    /* .hurda-trust stendur UTAN .checkout, thvi .checkout er limdur vid
       nedri brun skjasins. Vaeru merkin inni i honum myndu thau elta
       skrunid og standa alltaf a skjanum. .checkout er haft sem varaleid
       ef bygging kaflans breytist. */
    var box = document.querySelector('.pdp-hurda .hurda-trust')
           || document.querySelector('.pdp-hurda .checkout');
    /* Lyklakippurnar (.pdp-lk), gæludýramerkið (.pdp-gd) og barmmerkin (.pdp-bm) setja líka í
       körfu með fetch, án körfuforms, svo appið finnur ekkert til að festa
       merkin við. Þar fara þau neðst í .or-checkout, fyrir neðan
       traustlínurnar, sama stað og á hurðaskiltunum. .or-checkout er ekki
       límdur við skjáinn (það er .or-bar, stikan neðst í síma). Sé
       körfuform samt á síðunni setur appið merkin þar sjálft, og þá er
       ekkert akkeri búið til svo merkin komi ekki tvisvar. */
    if (!box && !document.querySelector('form[action*="/cart/add"]')) {
      box = document.querySelector('.pdp-lk .or-checkout')
         || document.querySelector('.pdp-gd .or-checkout')
         || document.querySelector('.pdp-bm .or-checkout');
    }
    if (!box) return;
    if (document.getElementsByClassName(PAY_ANCHOR).length) return;
    var d = document.createElement('div');
    d.className = PAY_ANCHOR;
    box.appendChild(d);
  }

  function swap() {
    var nodes = document.querySelectorAll('.trust .trust-icon');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.getAttribute('data-sm-icon')) continue;
      var ch = (el.textContent || '').trim();
      var svg = ICONS[ch];
      if (!svg) continue;
      el.setAttribute('data-sm-icon', ch);
      el.innerHTML = svg;
    }
  }

  /* 14.10: textinn "Við bjóðum uppá allar helstu greiðsluleiðir" kemur úr stillingum Trust Badges appsins (ekki úr þemanu); appið
     setur hann inn eftir hleðslu. Lagað hér ("upp á") þar til appið fer út. Hættir að fylgjast með eftir 20 sek. */
  function lagaGreidslutexta() {
    var h = document.querySelectorAll('.giraffly-right-Bar-Preview-width h3');
    for (var i = 0; i < h.length; i++) {
      for (var n = h[i].firstChild; n; n = n.nextSibling) {
        if (n.nodeType === 3 && n.nodeValue.indexOf('uppá') > -1) n.nodeValue = n.nodeValue.replace(/uppá/g, 'upp á');
      }
    }
  }
  function fylgjastMedTexta() {
    lagaGreidslutexta();
    if (!window.MutationObserver || !document.body) return;
    var mo = new MutationObserver(lagaGreidslutexta);
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }

  function run() {
    swap();
    payAnchor();
    fylgjastMedTexta();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
